<template>
    <button
      @click="selectOption"
      @keyup.up.prevent="$emit('up')"
      @keyup.down.prevent="$emit('down')"
      @keyup.esc.prevent="$emit('esc')"
      :disabled="disabled"
      class="font-body active:border-solid flex whitespace-nowrap border-0 py-sm pl-twentyFive pr-fifty text-signableBrandColours-black text-12 outline-0 bg-transparent"
      :class="{
        'cursor-pointer hover:bg-offWhite focus-visible:bg-offWhite active:bg-signableBrandColours-white': !disabled,
        'opacity-70 cursor-not-allowed': disabled,
      }"
    >
      {{ text }}
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        action: {
            type: Function,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
      function selectOption() {
        if (!props.disabled) {
          props.action();
          emit('selected');
        }
      }
      return {
        selectOption,
      };
    },
});
</script>
